// extracted by mini-css-extract-plugin
export default {"item":"Genre_item__3W3Ho","text":"Genre_text__zO0nS"};